import React from "react";
import Progress from "../../../common/components/progress";
import Error, { mapApplicationErrorInfoToErrorComponentProps } from "../../../common/components/error-new";
import TeamListTable from "../../../common/components/team-list-table";
import { createFunctionalComponentFromView } from "../../../utils/view-controller";
import useAllTeamsController from "./controller";
import "./index.scss";
import FilterDropDown from "../../../common/components/filter-dropdown";
import SearchBar from "../../../common/components/search-bar";
import ExportTeams from "../export-teams";
import TextButton from "../../../common/components/text-button";

const AllTeams = createFunctionalComponentFromView<ReturnType<typeof useAllTeamsController>, unknown>(
  useAllTeamsController,
  (controller) => {
    const renderContent = () => {
      if (controller.shouldRenderProgressMessage()) {
        return (<Progress text={controller.getProgressMsg()} />);
      }
      else if (controller.shouldRenderErrorMessage()) {
        return (
          <Error

            {...mapApplicationErrorInfoToErrorComponentProps(controller.getErrorMsg()!)}
            onClick={controller.onClickRetryFetchAllTeams}
          />
        );
      }
      else if (controller.shouldRenderNoAssociatedTeamsMessage()) {
        return <div className="no-teams">No teams to display</div>;
      }
      else {
        return (
          <TeamListTable
            teams={controller.getTeamList()}
            onRowClickedHandler={controller.onTableRowClickedHandler}
          />
        );
      }
    };

    const renderFilterAndSearch = () => {
      if (controller.shouldRenderFiltersAndCount()) {
        return (
          <div className="filter-and-search">
            <FilterDropDown
              className="all-team-filter"
              options={controller.getTeamTypeDropdownOptions()}
              title="Type"
              onChangeHandler={controller.onChangeTeamTypeFilter}
              selectedOptions={controller.getSelectedTeamType()}
              width={440}
            />
            <FilterDropDown
              className="all-team-filter"
              options={controller.getInternalOpenSourceDropdownOptions()}
              title="Internal open source"
              onChangeHandler={controller.onChangeInternalOpenSourceFilter}
              selectedOptions={controller.getInternalOpenSourceSelectedValue()}
            />
            <FilterDropDown
              className="all-team-filter"
              options={controller.getTeamStatusDropdownOptions()}
              title="Status"
              onChangeHandler={controller.onChangeTeamStatusFilter}
              selectedOptions={controller.getTeamStatusSelectedValue()}
            />
            <TextButton
              label="Reset"
              className="reset-all-team-filter"
              onClick={controller.onClickResetButton}
            />
            <SearchBar
              label="All teams"
              className="all-team-search"
              searchText={controller.searchText}
              onChangeSearchText={controller.onChangeSearchText}
              onClickClearSearchText={controller.onClickClearSearchText}
            />
          </div>
        );
      }
    };

    const renderAllTeamsCount = () => {
      if (controller.shouldRenderFiltersAndCount()) {
        return (
          <div className="teams-count">
            {controller.getTeamsCountMessage()}
          </div>
        );
      }
      return null;
    };

    const renderExportAllTeamsLink = () => {
      if (controller.shouldRenderExportAllTeamsLink()) {
        return (
          <ExportTeams
            title="All_Teams"
            teams={controller.getTeamList()}
          />
        );
      }
      return null;
    };

    return (
      <div className="AllTeams">
        {renderFilterAndSearch()}
        <div className="teams-count-and-export">
          {renderAllTeamsCount()}
          {renderExportAllTeamsLink()}
        </div>
        {renderContent()}
      </div>
    );
  });

export default AllTeams;
